export const COOKIE_CONSENT_NAME = {
  ARGOS: 'CONSENTMGR',
  HABITAT: 'CONSENTMANAGER',
  TU: 'CONSENTMGR_TU2',
  ONETRUST: 'OptanonConsent'
}

export const CONSENT_CATEGORIES = {
  PERFORMANCE: 'performance',
  FUNCTIONAL: 'functional',
  MARKETING: 'marketing'
}

export const ONETRUST_CATEGORIES = {
  performance: '2',
  functional: '3',
  marketing: '4'
}
